import { cn } from "@/lib/utils";

type BrandLogoProps = {
  className?: string;
  imageClassName?: string;
};

export default function BrandLogo({ className, imageClassName }: BrandLogoProps) {
  return (
    <a href="https://www.nitfisio.com.br" target="_blank" rel="noopener noreferrer" className={cn("rounded-2xl bg-primary/10 p-1.5 cursor-pointer", className)}>
      <img
        src="/nitfisio-logo.svg"
        alt="Logo Serafisio"
        loading="eager"
        className={cn("h-full w-full object-contain", imageClassName)}
      />
    </a>
  );
}
